import { ChangeDetectorRef, Component, inject, ChangeDetectionStrategy } from '@angular/core';

import type { FullCandidate } from '@core/candidate-types';
import {
  BoxComponent,
  DialogBodyComponent,
  DialogData,
  DialogHeaderComponent,
  SpinnerComponent,
} from '@core/user-interface-legacy';

@Component({
  selector: 'rt-candidate-profile-photo-preview',
  templateUrl: './candidate-profile-photo-preview.component.html',
  styleUrls: ['./candidate-profile-photo-preview.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [DialogHeaderComponent, DialogBodyComponent, BoxComponent, SpinnerComponent],
})
export class CandidateProfilePhotoPreviewDialogComponent {
  private readonly data = inject<{
    candidate: FullCandidate;
  }>(DialogData);
  protected readonly cdRef = inject(ChangeDetectorRef);

  public candidate: FullCandidate = this.data.candidate;
  public loading: boolean = true;
  public photoUrl: string | null = null;

  public ngOnInit(): void {
    this.loadCandidateImage();
  }

  private loadCandidateImage(): void {
    const candidatePreview = new Image();
    candidatePreview.onload = () => {
      this.photoUrl = candidatePreview.src;
      this.loading = false;
      this.cdRef.detectChanges();
    };
    candidatePreview.src = this.candidate.photoUrl;
  }
}
